var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56619_21061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83465 8.50035C5.83465 7.7727 5.86058 7.04376 5.91194 6.33105H0.778408C0.595094 7.03051 0.5 7.75809 0.5 8.50035C0.5 9.2426 0.595094 9.97018 0.778408 10.6696H5.91191C5.86058 9.95694 5.83465 9.22799 5.83465 8.50035Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 8.50035C6.83203 9.24234 6.85886 9.96962 6.91086 10.6696H11.0917C11.1437 9.96962 11.1706 9.24234 11.1706 8.50035C11.1706 7.75839 11.1437 7.03108 11.0917 6.33105H6.91086C6.85886 7.03108 6.83203 7.75839 6.83203 8.50035Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2214 6.33105H12.0879C12.1392 7.04376 12.1652 7.7727 12.1652 8.50035C12.1652 9.22799 12.1392 9.95694 12.0879 10.6696H17.2214C17.4047 9.97018 17.4998 9.2426 17.4998 8.50035C17.4998 7.75809 17.4047 7.03051 17.2214 6.33105Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 11.665C7.1326 12.7999 7.33136 13.839 7.5927 14.7207C8.0594 16.2949 8.63644 16.9997 9.00127 16.9997C9.36611 16.9997 9.94315 16.2949 10.4098 14.7207C10.6712 13.839 10.8699 12.7999 10.9986 11.665H7.00391Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9986 5.33461C10.8699 4.1997 10.6712 3.16061 10.4098 2.27896C9.94315 0.70467 9.36611 0 9.00127 0C8.63644 0 8.0594 0.70467 7.5927 2.27896C7.33136 3.16064 7.1326 4.19973 7.00391 5.33461H10.9986Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8938 5.33473C16.4718 4.28209 15.8373 3.31575 15.0113 2.48969C13.7876 1.26599 12.2562 0.461908 10.5918 0.148438C11.2945 1.29693 11.767 3.19854 11.9991 5.3347H16.8938V5.33473Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 16.8513C12.2543 16.5379 13.7856 15.7338 15.0093 14.51C15.8354 13.684 16.4699 12.7177 16.8918 11.665H11.9972C11.765 13.8012 11.2926 15.7028 10.5898 16.8513Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10742 11.665C1.52937 12.7177 2.16388 13.684 2.98991 14.51C4.21364 15.7338 5.74494 16.5379 7.40934 16.8513C6.70663 15.7028 6.23418 13.8012 6.00206 11.6651L1.10742 11.665Z",
    fill: "#003A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40934 0.148438C5.74494 0.461875 4.21364 1.26596 2.98991 2.48969C2.16388 3.31575 1.52937 4.28206 1.10742 5.33473H6.00206C6.23418 3.19854 6.70663 1.29693 7.40934 0.148438Z",
    fill: "#003A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56619_21061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.b001becd9be30998cff6d391a41a7291.svg";
export { ForwardRef as ReactComponent };